import { render, staticRenderFns } from "./showdatainvitecomponents.vue?vue&type=template&id=49fa4595"
import script from "./showdatainvitecomponents.vue?vue&type=script&lang=js"
export * from "./showdatainvitecomponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports